import { create } from 'zustand';

const useFacilityStore = create((set) => ({
  facility: {},

  setFacility: (newFacility) => set({ facility: newFacility }),

  clearFacility: () => set({ facility: {} }),
}));

export default useFacilityStore;
